const initialState = {
  fetching: false,
  fetched: false,
  items: [],
  error: null,
  suggestions: {
    fetching: false,
    fetched: false,
    items: []
  },
  current: null,
  saving: false,
  saved: false
};

export const indicatorsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_INDICATORS_LIST_PENDING": {
      return { ...state, fetched: false, fetching: true };
    }
    case "FETCH_INDICATORS_LIST_FULFILLED": {
      const { data } = action.payload;
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: data || []
      };
    }
    case "FETCH_INDICATORS_LIST_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        items: [],
        error
      };
    }
    case "FETCH_SUPPORTED_INIDCATOR_VARS_PENDING": {
      return { ...state, suggestions: { fetched: false, fetching: true } };
    }
    case "FETCH_SUPPORTED_INIDCATOR_VARS_FULFILLED": {
      const { data } = action.payload;
      return {
        ...state,
        suggestions: {
          fetched: true,
          fetching: false,
          items: data || []
        },
        error: null
      };
    }
    case "FETCH_SUPPORTED_INIDCATOR_VARS_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        suggestions: {
          fetching: false,
          items: []
        },
        error
      };
    }

    case "UPDATE_INDICATOR_PENDING": {
      return { ...state, saved: false, saving: true };
    }
    case "UPDATE_INDICATOR_FULFILLED": {
      let { data } = action.payload.data;
      let indicators = [...state.items].map(indicator => {
        if (data && data.id === indicator.id) {
          return data;
        }

        return indicator;
      });

      return { ...state, saved: true, saving: false, items: indicators };
    }
    case "UPDATE_INDICATOR_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
      }
      return {
        ...state,
        saved: false,
        error
      };
    }
    case "DEFINE_INDICATOR_PENDING": {
      return { ...state, saved: false, saving: true };
    }
    case "DEFINE_INDICATOR_FULFILLED": {
      let { data } = action.payload.data;
      let indicators = [...state.items];
      indicators.push({
        formula: data.formula,
        id: data.id,
        code: data.code,
        labels: data.labels,
        unit: data.unit
      });
      return { ...state, saved: true, saving: false, items: indicators };
    }
    case "DEFINE_INDICATOR_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
      }
      return {
        ...state,
        saved: false,
        error
      };
    }
    case "DELETE_INDICATOR_PENDING": {
      return { ...state, saved: false, saving: true };
    }
    case "DELETE_INDICATOR_FULFILLED": {
      let { params } = action.payload.config;
      let indicators = [...state.items].filter(indicator => {
        return params.id !== indicator.id;
      });
      return { ...state, saved: true, saving: false, items: indicators };
    }
    case "DELETE_INDICATOR_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
      }
      return {
        ...state,
        saved: false,
        error
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/indicator.js